@if (opened) {
  <aside class="notifications" [ngClass]="{'notifications_opened': opened}" (appClickOutside)="clickOutside()" [@slideLeft]>
    <ul class="notifications__list">
      @for (el of notificationsQueue.notifications; track el) {
        <li class="notifications__element">
          <span class="notifications__element__caption">{{el.subject}}</span>
          <span class="notifications__element__text">{{el.body}}</span>
          <a href="javascript:void(0)" (click)="removeNotification(el)"
          class="notifications__element__close icon icon_theme_crm icon_delete_sign"></a>
        </li>
      }
    </ul>
  </aside>
}
